import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { Category } from "../types";

export interface CategoriesState {
  items: Category[]
  loading: boolean;
}

const initialState: CategoriesState = {
  items: [],
  loading: false,
};

export const categories = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategories: (state, action: PayloadAction<Category[]>) => {
      state.items = action.payload;
    },
    clearCategories: (state) => {
      state.items = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setCategories, clearCategories, setLoading } = categories.actions;

export const selectCategories = (state: RootState) => state.categories.items;
export const selectIsCategoryLoading = (state: RootState) => state.categories.loading;

export default categories.reducer;
